import React from 'react';

import DonationDetails from '@/core/components/DonationDetails';
import { DonationSide } from '@/core/components/DonationDetails/DonationSide';
import Icons from '@/core/components/Icons';
import { useComponentsContext } from '@/core/lib/components/components.context';
import { useNativeContext } from '@/core/lib/native/native.context';
import Store from '@/core/lib/new-architecture/store';
import { useRouterContext } from '@/core/lib/router/router.context';
import Routes from '@/core/lib/router/routes';
import { useTranslationContext } from '@/core/lib/translation/translation.context';
import type { PageWithLayoutsAndProviders } from '@/core/pages/page.types';
import { DonationState } from '@/core/types/donation';

const DonationDetailPage: PageWithLayoutsAndProviders = () => {
  const { t } = useTranslationContext(['common', 'donation-detail']);
  const { back, query, onGlobalNotFound } = useRouterContext();
  const { Page, Content, Head } = useComponentsContext();
  const { isNative } = useNativeContext();

  const onBack = () => back(new Routes.CatalogueRoute({}));

  const { data: donation, isLoading, notFound } = Store.donation.useDonation(Number(query.id));

  if (notFound) {
    onGlobalNotFound?.();
    return;
  }

  return (
    <Page noPadding={isNative}>
      <Head>{donation?.getState() === DonationState.ENDED ? <meta name="robots" content="noindex, nofollow" /> : null}</Head>
      <Content>
        <div className="flex flex-col items-center bg-bg-primary pb-safe-bottom">
          {isLoading ? (
            <div aria-label={t('spinner.aria-valuetext', { ns: 'donation-detail' })} className="flex h-screen items-center justify-center">
              <Icons icon="spinner" size="40" color="button-default" />
            </div>
          ) : (
            <>
              <DonationDetails donation={donation!} onBack={onBack} />
              {isNative && <DonationSide />}
            </>
          )}
        </div>
      </Content>
    </Page>
  );
};

export default DonationDetailPage;
